import { createSlice } from "@reduxjs/toolkit";
import { getTenants } from "../APIs/tenantAPI";

const initialState = {
  loading: false,
  error: {},
  status: "idle",
  tenantList: {
    result: [],
    totalRecords: 0,
  },
  inviteModal: {
    visible: false,
    tenant: {},
  },
  deleteModal: {
    visible: false,
    tenant: {},
  },
  showToastMessage: {
    visible: false,
    data: {},
  },
  currentTenant: {},
};

export const tenantsSlice = createSlice({
  name: "tenants",
  initialState,
  reducers: {
    updateTenants: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
  },
  extraReducers(builder) {
    builder.addCase(getTenants.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTenants.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.tenantList = action.payload;
    });
    builder.addCase(getTenants.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });
  },
});

export const { updateTenants } = tenantsSlice.actions;

export default tenantsSlice.reducer;
